import ApiBase from './base/ApiBase'
import { PortalAccessDiscovery } from '../models/portal-context';


class TokenClient extends ApiBase
{
    private controllerName: string = 'Token';

    async GetAccessToken(organizationId: string, idTokenString: string, impersonateOrganizationId: string, impersonateUserId: string, withAdmin: boolean, signal?: AbortSignal) : Promise<TokenResponse>
    {
        let uri = `${this.controllerName}/Access/${organizationId}`;
        if(impersonateOrganizationId && impersonateUserId)
            uri = `${uri}?impersonateOrganizationId=${impersonateOrganizationId}&impersonateUserId=${impersonateUserId}&withAdmin=${withAdmin}`;
        return this.PostAsync(uri, idTokenString, signal);
    }

    async GetOrganizations(idTokenString: string, signal?: AbortSignal) : Promise<OrganizationInfo[]>
    {
        return this.PostAsync(`${this.controllerName}/Organizations`, idTokenString, signal);
    }

    async GetContexts(idTokenString: string, signal?: AbortSignal): Promise<PortalAccessDiscovery>
    {
        return this.PostAsync(`${this.controllerName}/Contexts`, idTokenString, signal);
    }

    async GetEmployeePortalToken(idTokenString: string, signal?: AbortSignal): Promise<TokenResponse>
    {
        return this.PostAsync(`${this.controllerName}/EmployeePortal`, idTokenString, signal);
    }

    async GetProducerPortalToken(idTokenString: string, producerCompanyId: string, signal?: AbortSignal): Promise<TokenResponse>
    {
        return this.PostAsync(`${this.controllerName}/ProducerPortal/${encodeURIComponent(producerCompanyId)}`, idTokenString, signal);
    }

    /**
     * Exchanges a trusted B2C identity token for the deliberately restricted
     * onboarding token used before an organization exists.
     */
    async GetOnboardingToken(idTokenString: string, signal?: AbortSignal) : Promise<TokenResponse>
    {
        return this.PostAsync(`${this.controllerName}/Onboarding`, idTokenString, signal);
    }
}

export interface OrganizationInfo {
    Id: string;
    Name: string;
    IsSubscriptionActive: boolean;
    SubscriptionNotRequired: boolean;
    NeedToValidateSubscription: boolean;
  }

export interface TokenResponse {
    Token: string;
    Organizations?: OrganizationInfo[];
    ExpiresAt?: string;
    RequiresProfileCompletion?: boolean;
  }

export default TokenClient;
